export default {"src":"/_next/static/media/attention-icon.0332e023.svg","height":80,"width":81,"blurWidth":0,"blurHeight":0};